<template>
  <div>
    <!-- 导航栏 -->
    <div class="tabBar" v-show="isShowTabBar">
      <div class="logo">
        <img src="../assets/image_m/logo_m.png" alt />
      </div>
      <div class="box">
        <div class="search" @click="searchBtn">
          <img src="../assets/image_m/search.png" alt />
        </div>
        <a href="javascript:;" class="nav" @click="showNav">
          <img v-show="isShowNav" src="../assets/image_m/nav.png" alt />
          <img v-show="!isShowNav" src="../assets/image_m/close.png" alt />
        </a>
      </div>
    </div>
    <!-- 搜索栏 -->
    <div class="search_box" v-show="!isShowTabBar">
      <div class="tabBar">
        <div class="search_hotword">
          <div class="search_icon">
            <img src="../assets/image_m/search.png" alt />
          </div>
          <div class="search_input">
            <input type="text" placeholder="请输入关键词" />
          </div>
        </div>
        <div class="closeBtn" @click="isShowTabBar = true">
          <img src="../assets/image_m/close.png" alt />
        </div>
      </div>
      <ul class="hotword">
        <li>热门搜索：</li>
        <li>
          <a href>智能</a>
        </li>
        <li>
          <a href>万物物联</a>
        </li>
      </ul>
    </div>
    <!-- 菜单栏 -->
    <div class="navBar_box" v-show="!isShowNav">
      <ul class="navBar">
        <li class="item">
          <router-link tag="a" to="/home-m" href>首页</router-link>
        </li>
        <li class="item">
          <div class="item_bar" @touchstart="showItemBar1">
            <a href="javascript:;">产品展示</a>
            <img class="toggle1" src="../assets/image_m/bottom.png" alt />
          </div>
          <ul class="item_bar_1" v-show="isShowItemBar1">
            <li>
              <router-link tag="a" to="/wanwu-m" href>万物物联</router-link>
            </li>
            <li>
              <router-link tag="a" to="/robot-m" href>智能机器人</router-link>
            </li>
          </ul>
        </li>
        <li class="item">
          <router-link tag="a" to="/cases-m" href>成功案例</router-link>
        </li>
        <li class="item">
          <div class="item_bar" @touchstart="showItemBar2">
            <a href="javascript:;">关于远达</a>
            <img class="toggle2" src="../assets/image_m/bottom.png" alt />
          </div>
          <ul class="item_bar_1" v-show="isShowItemBar2">
            <li>
              <router-link tag="a" to="/brief-m" href>公司简介</router-link>
            </li>
            <li>
              <router-link tag="a" to="/memory-m" href>大事记</router-link>
            </li>
            <li>
              <router-link tag="a" to="/honour-m" href>荣誉与认证</router-link>
            </li>
            <li>
              <router-link tag="a" to="/contact-m" href>联系我们</router-link>
            </li>
          </ul>
        </li>
        <li class="item">
          <router-link tag="a" to="/info-m" href>物联资讯</router-link>
        </li>
        <li class="item">
          <router-link tag="a" to="/made-m" href>个性化定制</router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      isShowNav: true,
      isShowItemBar1: false,
      isShowItemBar2: false,
      isShowTabBar: true,
    };
  },
  watch: {},
  computed: {},
  methods: {
    showNav() {
      this.isShowNav = !this.isShowNav;
    },
    showItemBar1() {
      var i = document.querySelector(".toggle1");
      this.isShowItemBar1 = !this.isShowItemBar1;
      if (this.isShowItemBar1 === true) {
        i.style.transform = "rotate(" + 180 + "deg)";
      } else {
        i.style.transform = "rotate(" + 0 + "deg)";
      }
    },
    showItemBar2() {
      var i = document.querySelector(".toggle2");
      this.isShowItemBar2 = !this.isShowItemBar2;
      if (this.isShowItemBar2 === true) {
        i.style.transform = "rotate(" + 180 + "deg)";
      } else {
        i.style.transform = "rotate(" + 0 + "deg)";
      }
    },
    searchBtn() {
      this.isShowTabBar = false;
      this.isShowNav = true;
    },
  },
  created() {},
  mounted() {},
  activated() {
    this.isShowNav = true;
  },
};
</script>
<style lang="less" scoped>
.tabBar {
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  height: 50px;
  display: flex;
  align-items: center;
  display: -webkit-flex;
  -webkit-align-items: center;
  -webkit-box-align: center;
  padding: 0 16px;
  background: #ffffff;
  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.05);
  z-index: 1000;
  .logo {
    width: 127px;
    height: 31px;
    img {
      width: 100%;
    }
  }
  .box {
    position: absolute;
    right: 16px;
    top: 14px;
    display: flex;
    display: -webkit-flex;
    .search {
      width: 22px;
      height: 22px;
      margin-right: 32px;
      cursor: pointer;
      img {
        width: 100%;
      }
    }
    .nav {
      width: 22px;
      height: 22px;
      cursor: pointer;
      img {
        width: 100%;
      }
    }
  }
}
.search_box {
  width: 100%;
  height: 100%;
  position: fixed;
  background: #ffffff;
  top: 0px;
  bottom: 0px;
  z-index: 1000;
  .tabBar {
    .search_hotword {
      width: 90%;
      height: 34px;
      background: #f5f5f5;
      border-radius: 22px;
      display: flex;
      display: -webkit-flex;
      -webkit-align-items: center;
      -webkit-box-align: center;
      align-items: center;

      .search_input {
        input {
          border: none;
          outline: none;
          background-color: transparent;
        }

        input::-webkit-input-placeholder {
          color: #999999;
        }

        input::-moz-placeholder {
          /* Mozilla Firefox 19+ */
          color: #999999;
        }

        input:-moz-placeholder {
          /* Mozilla Firefox 4 to 18 */
          color: #999999;
        }

        input:-ms-input-placeholder {
          /* Internet Explorer 10-11 */
          color: #999999;
        }
      }

      .search_icon {
        width: 22px;
        height: 22px;
        margin: 0 12px 0 16px;
        img {
          width: 100%;
        }
      }
    }
    .closeBtn {
      width: 22px;
      height: 22px;
      position: absolute;
      right: 16px;
      top: 14px;
      img {
        width: 100%;
      }
    }
  }
  .hotword {
    margin-top: 60px;
    padding-top: 28px;
    padding: 0 16px;
    li {
      padding: 16px 0;
      border-bottom: 1px solid #eaeaea;
      a {
        font-size: 16px;
      }
    }
  }
}
.navBar_box {
  margin-top: 50px;
  width: 100%;
  height: 100%;
  position: fixed;
  background: #ffffff;
  top: 0px;
  bottom: 0px;
  z-index: 1000;
  .navBar {
    padding: 8px 16px 0 16px;
    .item {
      border-bottom: 1px solid #eaeaea;
      padding: 16px 0;
      font-weight: Bold;
      .item_bar_1 {
        display: flex;
        flex-wrap: wrap;
        padding-top: 28px;
        li {
          padding: 0 16px;
          width: 130px;
          a {
            font-size: 16px;
          }
        }
        li:nth-child(-n + 2) {
          padding-bottom: 16px;
        }
      }
      a {
        font-size: 18px;
        color: #333333;
        &.router-link-active {
          color: #26acff;
        }
      }
      .item_bar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        img {
          height: 17px;
          width: 17px;
        }
      }
    }
  }
}
</style>